module.exports = __webpack_public_path__ + "img/Hee.dfc09fcb.jpg";